import React, { useState, useEffect, useRef } from 'react';

import { /*reqGET, repo_img_link,*/ reqPOST, content_language, translate, functionSendMail } from '../../../../Utils';

import * as Hosts from "../../../../Hosts";

import { language } from '../Language';

//import AssecImage from "../../ASSEC_Image/Image"

import Loader from '../../../../loader';
import Swal from 'sweetalert2';

import "./HomeNewsletter_01.css"

const HomeNewsletter = (props) => {

	const [, set_dados] = useState(null)
	const dados_config = useRef([])

    const [newsletter_title, set_newsletter_title] = useState('')
    const [newsletter_subtitle, set_newsletter_subtitle] = useState('')

    const [isloading, setLoading] = useState(true);

    const [lang, set_lang] = useState(localStorage.getItem('lang'));
    const [lang_id, set_lang_id] = useState('1');

    let data_interface_nl = {
        id: '',
        info: {
            companycode: '',
            username: '',
            password: '',
            name: '',
            name_comercial: '',
            sector: '',
            segmentation: [],
            language: 'pt',
            type: '0',
            darkmode: false,
            rgpd: false,
            terms: false,
            marketing: false,
            ativo: true,
            observation: ''
        },
        addresses: [{
            village: '',
            city: '',
            type: [],
            region: '',
            country: '',
            apartado: '',
            localidade: '',
            contats: [],
            principal: '',
            observation: '',
            postal_code: '',
            street_name: '',
            address_detail: '',
        }],
        contacts: [{
            email: '',
            phone: '',
            principal: 'true',
            extensions: [],
            observation: '',
            mobile_phone: '',
            building_number: '',
            person_responsables: [{
                name: '',
                email: '',
                extensions: '',
                observation: '',
                mobile_phone: ''
            }],
        }],
        profile: { name: "entity_nl" },
        notifications: []
    }
    const [entity_nl, set_entity_nl] = useState(data_interface_nl);
    const [entity_nl_name, set_entity_nl_name] = useState('');
    const [entity_nl_email, set_entity_nl_email] = useState('');

    useEffect(() => {

        if(props.dados_config !== undefined && props.dados_config !== null && props.dados_config !== '') {
            set_dados(dados_config.current = props.dados_config)
            
            for (let el of dados_config.current.content[0].components) {

                if(el.info.tag === 'newsletter' && el.info.active) {
                    set_newsletter_title(translate(el.info.title, lang))
                    set_newsletter_subtitle(translate(el.info.subtitle, lang))

                    //set_dados(newsletter_list.current.push(el))
                    setLoading(false)
                }
            }
        }

        if (localStorage.getItem('lang') === undefined || localStorage.getItem('lang') === null || localStorage.getItem('lang') === '') {
            set_lang('pt')
            set_lang_id('1')
        }
        else {
            set_lang(localStorage.getItem('lang'))
            content_language.forEach(el => {
                if (el.code === localStorage.getItem('lang')) {
                    set_lang_id(el.id)
                }
            })
        }

    }, [props, lang])

    const set_nl_contact = (e) => {
		const { value, name } = e.target;

        if(name === "name") {
            set_entity_nl_name(value)
        }
        else if(name === 'email') {
            set_entity_nl_email(value)
        }

        set_entity_nl(entity_nl)

    }

    const send_nl_contact = async () => {

        let terms = document.getElementById('terms_nl').checked

        if(entity_nl_name !== '' && entity_nl_email !== '' && terms) {

            entity_nl.info.name = entity_nl_name
            entity_nl.info.email = entity_nl_email
            entity_nl.info.companycode = Hosts.companycode_nl
            entity_nl.contacts[0].email = entity_nl_email
            
            entity_nl.info.rgpd = true
            entity_nl.info.terms = true
            entity_nl.info.marketing = true
            entity_nl.info.from = 'website'

            let res_c = await reqPOST(`${Hosts.SIMCore_API}/nl/entities`, entity_nl)
            if(parseInt(res_c.status) === 200) {

            let mail_content =  '<table width="600" cellpadding="0" cellspacing="0" border="0" align="0" class="0" style="width: 600px; height: 90px; padding: 15px 30px; background-color:' + Hosts.EMAIL_BACKGROUND_COLOR +';border:1px solid transparent;border-collapse:collapse;">' +
                '<tr style="border-collapse: collapse;">' +
                    '<td align="left" class style="padding:40px; font-family:poppins, helvetica, arial, sans-serif; font-size:' + Hosts.EMAIL_TEXT_SIZE +'; line-height:' + Hosts.EMAIL_TEXT_LINE_HEIGHT  +'; color:' + Hosts.EMAIL_TEXT_COLOR +'">' +
                        '<div>'+
                            '<h4>'+ language[lang].nl_form +':</h4>'+
                            '<span><b>'+ language[lang].name +': </b><label>' + entity_nl_name + '</label></span>' +
                            '<br/>'+
                            '<span"><b>Email: </b><label>' + entity_nl_email + '</label></span>' +
                            '<br/>'+
                            '<br/>'+
                            '<span">' + language[lang].newsletter_reg + '</span>' +
                            '<br/>'+
                        '</div>'+
                    '</td>' +
                '</tr>' +
            '</table>'

            let res = await functionSendMail(Hosts.contactFrom, [entity_nl_email], [Hosts.contactFrom], Hosts.webSiteTitle + ' - ' + language[lang].nl_form, mail_content, [], dados_config.current)

            if(res === true) {
                document.getElementById('terms_nl').checked = false
                set_entity_nl_name('')
                set_entity_nl_email('')

                Swal.fire({
                    title: language[lang].nl_form,
                    text: language[lang].sent_successfully,
                    icon: 'success',
                    confirmButtonColor: '#08396a',
                })
                
            }
            else {

                Swal.fire({
                    title: language[lang].nl_form,
                    text: language[lang].sent_error,
                    icon: 'warning',
                    confirmButtonColor: '#08396a',
                })

            }
            }
            else if(parseInt(res_c.data) === 422) {
            
            Swal.fire({
                title: language[lang].nl_form,
                text: language[lang].nl_email_error_message,
                icon: 'warning',
                confirmButtonColor: '#08396a',
            })

            }
            else {

            Swal.fire({
                title: language[lang].nl_form,
                text: language[lang].sent_error,
                icon: 'warning',
                confirmButtonColor: '#08396a',
            })

            }

        }
        else {
            if(entity_nl_name === '' || entity_nl_email === '') {
                Swal.fire({
                    title: language[lang].nl_form,
                    text: language[lang].nl_fields_required,
                    icon: 'warning',
                    confirmButtonColor: '#08396a',
                })
            }
            else if(!terms) {
                Swal.fire({
                    title: language[lang].nl_form,
                    text: language[lang].nl_terms_required,
                    icon: 'warning',
                    confirmButtonColor: '#08396a',
                })
            }
            else {
                Swal.fire({
                    title: language[lang].nl_form,
                    text: language[lang].nl_fields_required,
                    icon: 'warning',
                    confirmButtonColor: '#08396a',
                })
            }
        }
    }

    return (
        isloading ?
            <Loader />
		:
            <section id="HomeNewsletter_01">
                <div className="container">
                    <div className="row">
                        <div className="col-12 title-properties">
                            <h3 className="titulo-pp">
                                {newsletter_title}
                            </h3>
                            {
                            newsletter_subtitle !== '' ?
                                <h4 className={"subtitulo-pp"}>
                                    {newsletter_subtitle}
                                </h4>
                            :
                                null
                            }
                            <hr></hr>
                        </div>
                        
                        <div className="col-12 col-lg-8 mx-auto">
                            <div className={"newsletter-content"}>                                
                                <div className="row">
                                    <div className="col-12 text-center text-white">
                                        <div className="text-center mb-3">
                                            <div className="row">
                                                <div className="col-12 col-sm-5 form-group mb-2 mb-md-0">
                                                    <input name="name" value={entity_nl_name} type="text" className="form-control" placeholder={language[lang].name_placeholder} onChange={(e) => set_nl_contact(e)} />
                                                </div>
                                                <div className="col-12 col-sm-5 form-group mb-2 mb-md-0">
                                                    <input name="email" value={entity_nl_email} type="email" className="form-control" placeholder={language[lang].email_placeholder} onChange={(e) => set_nl_contact(e)} />
                                                </div>
                                                <div className="col-6 col-sm-2 mx-auto">
                                                    <button className="btn btn-primary rounded" type="button" onClick={() => send_nl_contact()}>{language[lang].subscribe}</button>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="form-group custom-control custom-checkbox mb-0 mt-2">
                                            <input type="checkbox" id="terms_nl" name="terms_nl" className="custom-control-input" />
                                            <label className="custom-control-label ms-2" htmlFor="terms_nl">{language[lang].agree_terms_conditions}</label>&nbsp;
                                            {
                                            lang !== 'pt' && dados_config.current.content !== undefined && dados_config.current.content[0]?.terms !== undefined && Object.keys(dados_config.current.content[0]?.terms).length > 0 && dados_config.current.content[0]?.terms[lang_id] !== undefined && dados_config.current.content[0]?.terms[lang_id] !== null && dados_config.current.content[0]?.terms[lang_id] !== '' && dados_config.current.content[0]?.terms[lang_id]?.link !== undefined && dados_config.current.content[0]?.terms[lang_id]?.link !== '' ?
                                                <a href={dados_config.current.content[0]?.terms[lang_id]?.link} aria-label={"Link - " + language[lang].terms_conditions + " (opens a new window)"} title={"Link - " + language[lang].terms_conditions} target="_blank" rel="noreferrer">
                                                    {language[lang].terms_conditions}
                                                </a>
                                            :
                                                dados_config.current.content !== undefined && dados_config.current.content[0]?.terms !== undefined && Object.keys(dados_config.current.content[0]?.terms).length > 0 && dados_config.current.content[0]?.terms['1'] !== null && dados_config.current.content[0]?.terms['1'] !== '' && dados_config.current.content[0]?.terms['1']?.link !== undefined && dados_config.current.content[0]?.terms['1']?.link !== '' ?
                                                    <a href={dados_config.current.content[0]?.terms['1']?.link} aria-label={"Link - " + language[lang].terms_conditions + " (opens a new window)"} title={"Link - " + language[lang].terms_conditions} target="_blank" rel="noreferrer">
                                                    {language[lang].terms_conditions}
                                                    </a>
                                            :
                                                null
                                            }
                                        </div>
                                    </div>
                                </div>
                                
                            </div>
                        </div>
                    </div>
                </div>
            </section>
    )
};
export default HomeNewsletter;